import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_Table = _resolveComponent("Table");
    const _component_VerticalDividedDialog = _resolveComponent("VerticalDividedDialog");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_btn, {
            disabled: _ctx.disabled,
            class: "brg-btn info outlined size-l",
            onClick: _ctx.handleClickActivatorBtn
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localeInfo.TaxInvoiceBtnText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"]),
        _createVNode(_component_VerticalDividedDialog, {
            "is-open": _ctx.isDialogOpen,
            "on-cancel": _ctx.handleClickCancelDialogBtn,
            "is-divided": false,
            "has-footer": !_ctx.isPublishDisabled,
            "has-left-title": false,
            "has-right-title": false,
            "dialog-css-class": "ratio-full",
            width: 1024,
            height: 900
        }, {
            title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localeInfo.TaxInvoiceHeaderTitle), 1 /* TEXT */)
            ]),
            leftSubTitle: _withCtx(() => _cache[0] || (_cache[0] = [])),
            leftContent: _withCtx(() => [
                _createVNode(_component_Table, { lc: _ctx.lc }, null, 8 /* PROPS */, ["lc"])
            ]),
            buttonSet: _withCtx(() => [
                _createVNode(_component_v_btn, {
                    class: "brg-btn info outlined size-xl width-m",
                    onClick: _ctx.handleClickCancelDialogBtn
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localeInfo.cancel), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createCommentVNode(" 발행 권한이 없으면 발행 할 수 없다 (UI 미노출) "),
                _createCommentVNode(" 이미 발행 상태면 발행 할 수 없다. "),
                _withDirectives(_createVNode(_component_v_btn, {
                    class: "brg-btn primary size-xl width-m",
                    disabled: _ctx.isPublishDisabled,
                    onClick: _ctx.handleClickPublishTaxInvoiceBtn
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localeInfo.publish), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "onClick"]), [
                    [_vShow, !_ctx.isPublishDisabled]
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-open", "on-cancel", "has-footer"])
    ]));
}
